module.exports = __webpack_public_path__ + "img/icon-pdf.f3beb9dd.svg";